import { createReducer } from '@reduxjs/toolkit'
import { setPinnedAddresses, togglePinnedAddress, setDefaultPinnedPools, setSearch } from './actions'

// Define the combined state interface
export interface PoolsState {
  pinnedAddresses: string[] // Admin-set or user-modified pinned pools
  defaultPinnedPools: string[] // Admin-set verified pools (read-only by default)
  allPairs?: string[]
  bulkPairsData?: any[]
  block?: number
  DailyPairData?: any
  searchPool?: string
}

// Define default verified pool addresses (admin-set, hardcoded or from env)
const DEFAULT_PINNED_POOLS = [
  '0x3e9a26b6edece5999aedeec9b093c851cdfec529', // shMON - WMON pool
  '0xec8eb233538abfc97f337da8ec3d1b57fbe31895', // WMON - USDC
  '0x530d46885d3c52afd2a20a555d0dd179ab91f600' // WMON - MDX
  // Add more verified pool addresses here
].map((addr) => addr.toLowerCase()) // Ensure lowercase

const initialState: PoolsState = {
  pinnedAddresses: [...DEFAULT_PINNED_POOLS], // Default to admin-verified pools
  defaultPinnedPools: [...DEFAULT_PINNED_POOLS], // Store admin-verified pools as read-only
  allPairs: [],
  bulkPairsData: [],
  block: 0,
  DailyPairData: undefined,
  searchPool: ''
}

export default createReducer<PoolsState>(initialState, (builder) => {
  builder
    // Handle setting pinned addresses (can override defaults)
    .addCase(setPinnedAddresses, (state, action) => {
      state.pinnedAddresses = action.payload.map((addr) => addr.toLowerCase())
    })
    // Handle toggling a single pinned address (optional for user interaction)
    .addCase(togglePinnedAddress, (state, action) => {
      const address = action.payload.toLowerCase()
      if (state.pinnedAddresses.includes(address)) {
        state.pinnedAddresses = state.pinnedAddresses.filter((addr) => addr !== address)
      } else {
        state.pinnedAddresses.push(address)
      }
    })
    // Handle admin setting default pinned pools (read-only, only admins can modify)
    .addCase(setDefaultPinnedPools, (state, action) => {
      const newDefaultPools = action.payload.map((addr) => addr.toLowerCase())
      state.defaultPinnedPools = newDefaultPools
      state.pinnedAddresses = [...newDefaultPools] // Reset pinned to defaults
    })
    .addCase(setSearch, (state, { payload: { searchPool } }) => {
      state.searchPool = searchPool
    })
})
